import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'

export default boot(({ app }) => {
  const i18n = createI18n({
    legacy: false,
    locale: 'es-ES', // idioma por defecto si no viene uno de la empresa
    fallbackLocale: 'es-ES', // idioma de respaldo si falla el principal
    globalInjection: true,
    messages
  })

  // pt-BR
  // es-AR
  // es-ES

  // Set i18n instance on app
  app.use(i18n)
})
